import {
  Component,
  OnInit,
  Directive,
  ElementRef,
  Input,
  HostListener,
  ViewChild
} from "@angular/core";
import { DialogService } from "../dialog";
import { DialogComponent } from "../dialog/dialog.component";
import { InProductsService } from "../../services/inventory/in-products.service";
import { DataService } from "../../services/data.service";
import { environment } from "../../../../environments/environment";
import { Observable } from "rxjs/Observable";
export interface ConfirmModel {
  title: string;
  message: string;
}

@Component({
  selector: "app-item-search",
  templateUrl: "./item-search.component.html",
  styleUrls: ["./item-search.component.css"]
})
export class ItemSearchComponent extends DialogComponent<ConfirmModel, boolean>
  implements ConfirmModel, OnInit {
  title: string;
  message: string;
  loading: boolean;
  itemloading: boolean;
  result: any = { item: [], result: false };;
  rtnData: any;
  selectedIndex: number = -1;
  private el: ElementRef;
  ItemSearchCost: boolean
  @Input() onReturn: string;
  @ViewChild("itemName") itemName: ElementRef;
  ShowStockQtyInItemlist: boolean = false
  constructor(dialogService: DialogService, private ips: InProductsService, private ds: DataService) {
    super(dialogService);
  }
  @HostListener("keydown", ["$event"])
  onKeyDown(e) {
    // e.preventDefault();
    if (e.which == 40 || e.keyCode == 40) {
      e.preventDefault();
      if (this.selectedIndex != -1 && this.selectedIndex < this.limit) {
        this.selectedIndex = this.selectedIndex + 1;

      }

      if (this.selectedIndex == this.limit) {
        this.selectPage(this.currentPage + 1)
      }
      return;
    } else if (e.which == 38 || e.keyCode == 38) {
      e.preventDefault();
      if (this.selectedIndex != 0 && this.selectedIndex < this.limit) {
        this.selectedIndex = this.selectedIndex - 1;
      }
      if (this.selectedIndex == this.limit) {

        this.setPages()
      }
      return;
    }
  }

  ngOnInit() {
    this.ItemSearchCost = environment.ShowCostPriceOnItemSearch

    var isx = (this.ds.Settings.ShowStockQtyInItemlist)
    this.ShowStockQtyInItemlist = isx.toLowerCase() == 'true'

    // this.LoadData();
    // this.rtnData.data = this.ds.Settings["itemdata"].data
    // if (this.rtnData.data == []) {
    this.LoadData();
    // }
  }
  FilterData: any = {
    SellingPricelevel: this.ds.Settings.SellingPriceLevelId,
    Branch: this.ds.Settings.BranchId,
    Location: this.ds.Settings.LocationId,
    RequestedList: {
      Start: 0,
      FiterText: "",
      Limit: 10,
      ItemTypeId: this.ds.Settings.ItemTypeId,
      CAType: this.ds.Settings.CAType
    },
    FilterData: {
      Name: "",
      Barcode: "",
      RefNo: "",
      CostPrice: "",
      SellingPrice: "",
      SupplierName: "",
      Dept: "",
      Cat: "",
      SubCat: "",
      Unit: "",
      StkQty: 0
    },
    ShowStockQtyInItemlist: this.ShowStockQtyInItemlist
  };
  currentPage: number;
  totalPage: number;
  pages: Observable<number[]>;
  limitList: any[];
  loaded = false;
  config: any = { range: 3 };
  size: number;
  limit: number = 10;
  confirm(item) {
    this.result = { item: item, result: true };
    this.close();
  }
  onChange(i) {
    this.limit = i;
    this.selectPage(1);
  }
  selectPage(page: number) {
    if (this.isValidPageNumber(page, this.totalPage)) {
      this.FilterData.RequestedList.Start = (page - 1) * this.limit;
      this.LoadData2();
      this.currentPage = page;
      this.setPages();
    }
  }
  getPages(offset: number, limit: number, size: number) {
    this.currentPage = this.getCurrentPages(offset, limit);
    this.totalPage = this.getTotalPages(limit, size);
    this.setPages();
  }
  setPages() {
    this.pages = Observable.range(-this.config.range, this.config.range * 2 + 1)
      .map(offset => this.currentPage + offset)
      .filter(page => this.isValidPageNumber(page, this.totalPage))
      .toArray();
  }
  getCurrentPages(offset: number, limit: number): number {
    return Math.floor(offset / limit) + 1;
  }
  getTotalPages(limit: number, size: number): number {
    return Math.ceil(Math.max(size, 1) / Math.max(limit, 1));
  }
  isValidPageNumber(page: number, totalPages: number): boolean {
    return page > 0 && page <= totalPages;
  }

  LoadData() {
    if (this.ds.Settings["ItemHistoryCache"]) {
      this.FilterData = this.ds.Settings["ItemHistoryCache"]
    }
    var f = this.FilterData.FilterData;
    if (f.Name == "" && f.Barcode == "" && f.RefNo == "" && f.CostPrice == 0 && f.SellingPrice == 0 && f.SupplierName == "" && f.Dept == "" && f.Cat == "" && f.SubCat == "" && f.Unit == "") {
      this.itemName.nativeElement.focus();
      return;
    }
    this.loading = true;
    // if(this.FilterData.)
    this.FilterData.ShowStockQtyInItemlist = this.ShowStockQtyInItemlist;
    this.ips.GetProductSearch(this.FilterData).subscribe(res => {
      if (res.Success) {
        this.rtnData = res;

        this.size = res.total;
        this.getPages(3, this.limit, this.size);
        this.loading = false;
        this.itemName.nativeElement.focus();
        this.selectedIndex = 0
        // var abc = document.getElementsByClassName("itemname")[0].getElementsByClassName("bkd")[0].innerHTML;
        // var bcd = this.fullData.data.find(x => x.Code == abc);
        // this.confirm(bcd);
        this.itemName.nativeElement.focus();
      }

    });
  }
  ngAfterViewInit() {
    setTimeout(() => {
      // this.itemName.nativeElement.focus();
    }, 1300);
  }
  LoadData3() {
    this.FilterData.ShowStockQtyInItemlist = this.ShowStockQtyInItemlist;
    this.ips.GetProductSearch(this.FilterData).subscribe(res => {
      if (res.Success) {
        this.rtnData = res;
        this.ds.Settings["ItemHistoryCache"] = this.FilterData;
        this.size = res.total;
        this.getPages(3, this.limit, this.size);
        //this.itemName.nativeElement.focus();
      }
    });
  }
  LoadData2() {
    this.FilterData.ShowStockQtyInItemlist = this.ShowStockQtyInItemlist;
    this.ips.GetProductSearch(this.FilterData).subscribe(res => {
      if (res.Success) {
        this.rtnData = res;
        this.size = res.total;
        this.selectedIndex = 0
        this.itemName.nativeElement.focus();
      }
    });
  }
  TabonKeyDown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.LoadData3();
    } else if (e.keyCode == 40 && e.which == 40) {
      this.selectedIndex = 0;
      document.getElementById("focustxt").focus()
    }
  }
  focustxtKeydown(e) {
    // console.log(e)
    if (e.keyCode == 13 && e.which == 13) {
      this.selectItem(this.rtnData.data[this.selectedIndex])
    } else if (e.keyCode == 40 && e.which == 40) {
      // this.selectedIndex++;
    }
  }
  selectItem(item) {
    this.confirm(item);
  }
  tableKeydown(v) {

  }
  SelectRow(i) {
    //  this.selectedIndex = i;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/item-search/item-search.component.ts